enum BillSearchView {
  Card = 'Card',
  Table = 'Table',
}

export default BillSearchView;
